import React, { useEffect } from "react";
import { Button, Col, Form, Modal, Nav, Row, Tab } from "react-bootstrap";
import Select from "react-select";
import StaffFilterFunctions from "./functions";
import NoDataComponent from "../../CommanComponents/NoDataComponent";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const StaffFilterModal = (props) => {
    const {
        getdepartment,
        departmentList,
        getRoleList,
        roleList,
        hospitalsListing,
        adminStatus,
        handleRoleFilters,
        handleAdminStatus,
        departmentValues,
        hospitalValues,
        handleDepartmentFilters,
        applyFilters,
        handleClearAllFilters,
        handleHospitalsFilters,
        getHospitalListing,
        hospitalsList,
        hospitalsSearch,
        handleHospitalsSearch
    } = StaffFilterFunctions(props);


    useEffect(() => {
        getdepartment();
        getRoleList();
        getHospitalListing('');
    }, []);


    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.close}
                centered
                className="staff_filter_modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="filter_details">
                        <Tab.Container
                            id="left-tabs-example"
                            defaultActiveKey="first"
                        >
                            <Row>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={5}>
                                    <Nav
                                        variant="pills"
                                        className="flex-column"
                                    >
                                        <Nav.Item>
                                            <Nav.Link eventKey="first">
                                                Department
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">
                                                Role
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">
                                                Hospital
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="fourth">
                                                Status
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={7}>
                                    <div className="content_area">
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <div className="dropdown_box">
                                                    {departmentList &&
                                                        departmentList.length >
                                                        0 ? (
                                                        <div className="dropdown_area">
                                                            <Select
                                                                autoFocus={
                                                                    false
                                                                }
                                                                placeholder={
                                                                    "Department Name"
                                                                }
                                                                options={
                                                                    departmentList
                                                                }
                                                                value={departmentValues}
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleDepartmentFilters(e);
                                                                }}
                                                            />
                                                        </div>
                                                    ) :
                                                        <NoDataComponent
                                                            message="No Department Found!"
                                                        />}
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                {/* <div className="check_boxes">
                                                    <Form>
                                                        <div
                                                            key={"radio"}
                                                            className="mb-3"
                                                        >
                                                            {roleList &&
                                                                roleList.map(
                                                                    (item,index
                                                                    ) => {
                                                                        return (
                                                                            <Form.Check
                                                                                key={ index}
                                                                                type={"radio"}
                                                                                // id={`check-api-radio`}
                                                                                id={item.id}
                                                                            >
                                                                                <Form.Check.Input
                                                                                    type={"radio" }
                                                                                    isValid
                                                                                    checked={item.checked}
                                                                                    onClick={() =>handleRoleFilters(item)
                                                                                    }
                                                                                />
                                                                                <Form.Check.Label>
                                                                                    {item.title}
                                                                                </Form.Check.Label>
                                                                            </Form.Check>
                                                                        );
                                                                    }
                                                                )}
                                                        </div>
                                                    </Form>
                                                </div> */}
                                                <div className="check_box_slider">
                                                    {
                                                        roleList && roleList.length > 0 ?
                                                            roleList.map((item, i) => (
                                                                <Form.Check
                                                                    key={i}
                                                                    type="checkbox"
                                                                    id={item.id}
                                                                    label={item.title}
                                                                    checked={item.checked}
                                                                    onChange={() => handleRoleFilters(item)}
                                                                />
                                                            ))
                                                            :
                                                            <NoDataComponent
                                                                message="No Role Found!"
                                                            />
                                                    }
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <Form className="ward_form">
                                                    <Form.Group className="form-group">
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="No Selected"
                                                            value={hospitalsSearch}
                                                            onChange={handleHospitalsSearch}
                                                        />
                                                        <a >
                                                            <div className="icon">
                                                                <FontAwesomeIcon icon={faSearch} />
                                                            </div>
                                                        </a>
                                                    </Form.Group>
                                                    <div className="check_box_slider">
                                                        {
                                                            hospitalsList && hospitalsList.length > 0 ?
                                                                hospitalsList.map((item, i) => (
                                                                    <Form.Check
                                                                        key={i}
                                                                        type="checkbox"
                                                                        id={item.id}
                                                                        label={item.title}
                                                                        checked={item.checked}
                                                                        onChange={() => handleHospitalsFilters(item)}
                                                                    />
                                                                ))
                                                                :
                                                                <NoDataComponent
                                                                    message="No data Found!"
                                                                />
                                                        }
                                                    </div>
                                                </Form>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fourth">
                                                <div className="check_boxes">
                                                    <Form>
                                                        <div
                                                            key={"radio"}
                                                            className="mb-3"
                                                        >
                                                            {adminStatus &&
                                                                adminStatus.map(
                                                                    (
                                                                        item,
                                                                        index
                                                                    ) => {

                                                                        return (
                                                                            <Form.Check
                                                                                key={index}
                                                                                type={"radio"}
                                                                                // id={`check-api-radio`}
                                                                                id={item.id}
                                                                            >
                                                                                <Form.Check.Input
                                                                                    type={"radio"}
                                                                                    isValid
                                                                                    checked={item.checked}
                                                                                    onChange={(e) => (e.preventDefault(), handleAdminStatus(item))}
                                                                                />
                                                                                <Form.Check.Label onClick={(e) => (e.preventDefault(), handleAdminStatus(item))}>
                                                                                    {
                                                                                        item.label
                                                                                    }
                                                                                </Form.Check.Label>
                                                                            </Form.Check>
                                                                        );
                                                                    }
                                                                )}
                                                        </div>
                                                    </Form>
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </Col>
                            </Row>
                        </Tab.Container>
                        <div className="btn_area">
                            <Button
                                className="cancelBtn"
                                type="button"
                                onClick={() => handleClearAllFilters()}
                            >
                                Clear All
                            </Button>
                            <Button
                                className="submitBtn"
                                type="submit"
                                onClick={() => applyFilters()}
                            >
                                Apply
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default StaffFilterModal;
